var BaseTransportProvider = (function () {
    function BaseTransportProvider() {
    }
    BaseTransportProvider.prototype.extractHeaders = function (headersString) {
        var arr = headersString.trim().split(/[\r\n]+/);
        return arr.map(function (line) {
            var parts = line.split(': ');
            var name = parts.shift();
            var value = parts.join(': ');
            var header = new window.com.ts.mobile.sdk.TransportHeader();
            header.setName(name);
            header.setValue(value);
            return header;
        });
    };
    BaseTransportProvider.prototype.sendRequest = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            function rejectWithCommunicationError() {
                reject();
            }
            xhr.open(request.getMethod(), request.getUrl(), true);
            xhr.withCredentials = false;
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    try {
                        if (xhr.status === 0) {
                            return reject();
                        }
                        var response = new window.com.ts.mobile.sdk.TransportResponse();
                        response.setStatus(xhr.status);
                        response.setMethod(request.getMethod());
                        response.setHeaders(_this.extractHeaders(xhr.getAllResponseHeaders()));
                        response.setBodyJson(xhr.responseText);
                        resolve(response);
                    }
                    catch (ex) {
                        rejectWithCommunicationError();
                    }
                }
            };
            xhr.onerror = function () {
                rejectWithCommunicationError();
            };
            request.getHeaders().forEach(function (header) {
                xhr.setRequestHeader(header.getName(), header.getValue());
            });
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(request.getBodyJson());
        });
    };
    return BaseTransportProvider;
}());
export default BaseTransportProvider;
